module.exports = __webpack_public_path__ + "static/aircraft-sale-banner-73d597d29656b596c13b6d1bb06ca232.jpg";